import React from "react";
import Calendly from "@/src/components/Calendly/Calendly";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { getCustomerConsent } from "@/src/services/customerService";
import RecordingConsentForm from "@/src/components/Form/Common/RecordingConsent/RecordingConsentForm";

const CalendlyPage = ({}) => {
  const { customer } = useCustomer();

  const consent = customer ? getCustomerConsent(customer, "callRecordingAndSummary") : null;

  return (
    <LayoutProtectedRoutes>
      {consent && <Calendly />}
      {!consent && <RecordingConsentForm handleConsent={(state: string) => {}} />}
    </LayoutProtectedRoutes>
  );
};

export default CalendlyPage;
